import { render } from "./Details.vue?vue&type=template&id=23aadfdc&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-23aadfdc"

export default script